/**
 * Portal routing helpers.
 *
 * The same `CommonClinicRoutes` block is mounted under two roots:
 *   `/`                     (admin + clinic staff)
 *   `/practitioner-portal`  (practitioner)
 *
 * To navigate to a shared route from anywhere, we sniff the current pathname
 * for the practitioner prefix and prepend it; everything else assumes root.
 */

const PORTAL_PREFIXES = ['/practitioner-portal'] as const;

export function getActivePortalPrefix(pathname: string = window.location.pathname): string {
  for (const prefix of PORTAL_PREFIXES) {
    if (pathname === prefix || pathname.startsWith(prefix + '/')) {
      return prefix;
    }
  }
  return '';
}

/** Build a path inside the current portal — e.g. `visit/:id` → `/practitioner-portal/visit/:id`. */
export function portalPath(relative: string, pathname?: string): string {
  const trimmed = relative.replace(/^\//, '');
  return `${getActivePortalPrefix(pathname)}/${trimmed}`;
}

export function visitCockpitPath(encounterId: string, pathname?: string): string {
  return portalPath(`visit/${encounterId}`, pathname);
}
